/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class MomentumProgramAccess {
    momentumId: string;
    gmin: string;
    fullName: string;

    constructor() {
    }

    setData(row: any) {
        this.momentumId = row.momentumId;
        this.gmin = row.gmin;
        this.fullName = row.fullName;
    }
}